export const DevGraphQl = 'https://apis-v2.residentboost.com';
export const Development = 'https://api.residentboost.com/api';
export const apisWebsocketUrl =
  import.meta.env.VITE_APIS_WS_URL || 'https://apis-v2.residentboost.com';

export const kelseyBasePath = 'https://kelsey.getzuma.com';
export const Production = import.meta.env.VITE_SERVERURL;
export const ProductionGraphql = import.meta.env.VITE_GRAPHQL;
export const imageBaseUrl = import.meta.env.VITE_ZUMA_ASSETS;

// The CFX dashboard ("Client Portal"), which owns community settings since the
// Retool was retired (ZUM-3610).
export const dashboardBasePath =
  import.meta.env.VITE_DASHBOARD_URL || 'https://client.getzuma.com';

/**
 * Community settings live in the dashboard, which scopes the page by client.
 * Opened in a new tab — the dashboard is a separate origin with its own
 * session, and it will bounce through login (preserving `returnTo`) if the user
 * doesn't have one yet.
 */
export const communitySettingsUrl = (clientId: string, communityId: string) =>
  `${dashboardBasePath}/clients/${clientId}/communities/${communityId}`;
